import moment from "moment"

const sortKeys = ["sortBy", "sortDir"]

const filterCatalogs = (filter, items) => {
    return [...items].filter(catalog => isCatalogMatchesFilter(catalog, filter))
}

const pagination = { total: 0, perPage: 0, currPage: 0 }
const paginationKeys = Object.keys(pagination)

function isCatalogMatchesFilter(catalog, filter) {
    const keys = Object.keys(filter)
        .filter(key => key in catalog)
        .map(key => key)

    if (!keys.includes("company")) {
        keys.push("company")
    }

    // removes sortkeys
    let filterKeys = Object.keys(filter).filter(key => !sortKeys.includes(key))
    filterKeys = filterKeys.filter(key => !paginationKeys.includes(key))

    if (
        filterKeys.length &&
        !filterKeys.includes("version") &&
        !filterKeys.includes("lastPublishAt") &&
        !keys.length
    ) {
        return false
    }

    return [...filterKeys, ...keys].every(key => {
        const filterValue = filter[key]
        if (filterValue === undefined) return true

        const filterValueUpper = filterValue.toUpperCase()
        let catalogValue = catalog[key]

        if (key === "version") {
            catalogValue = catalog.setting?.version
        }

        if (key === "lastPublishAt") {
            if (!catalog.setting) return false
            if (!catalog.setting.lastPublishAt) return false

            const filterDateValue = moment(filterValue, "MM/DD/YYYY")
            const catalogDateValue = moment(
                catalog.setting.lastPublishAt,
                moment.ISO_8601
            )
            return catalogDateValue.isAfter(filterDateValue)
        }

        if (["company", "iconSet"].includes(key)) {
            if (key === "company") {
                if (filterValueUpper.toUpperCase() === "UNASSIGNED") {
                    return catalogValue === undefined || catalogValue === null
                }
            }

            if (catalogValue === undefined || catalogValue === null) return false
            if (typeof catalogValue !== "object" || !("name" in catalogValue))
                return false
            return catalogValue.name.toUpperCase().includes(filterValueUpper)
        }

        const catalogValueUpper = String(catalogValue).toUpperCase()
        return catalogValueUpper.includes(filterValueUpper)
    })
}

export default filterCatalogs
